import { render } from "./ProjectBoardPage.vue?vue&type=template&id=0847b004&ts=true"
import script from "./ProjectBoardPage.vue?vue&type=script&lang=ts"
export * from "./ProjectBoardPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__